/* System defined core library */
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { SelectedExamDetailService } from '../../../scheduling/shared/services/selected-exam-detail.service';

@Component({
  selector: 'close-button',
  templateUrl: './close-button.component.html'
})

export class CloseButtonComponent implements OnInit {

  /* Input-OutPut parameters decalartions */
  @Input() isDisable: boolean = false;
  @Input() isHiddenPrint: boolean = false;
  @Output() onClick: EventEmitter<any> = new EventEmitter<any>();
  @Input() hasContent: string = "";
  @Input() ariaLabel: string = "Finish: Back to Home page.";
  @Input() showRestartIcon: boolean = false;

  /* Constructor declaration with required injected services */
  constructor(private selectedExamDetailService: SelectedExamDetailService) {
  }

  ngOnInit(): void {
  }

  /*Emit Click Event */
  submit(event: any) {
    this.onClick.emit(event);
  }

  getClass() {
    let programCode = this.selectedExamDetailService.programCode ? this.selectedExamDetailService.programCode.toLowerCase() : '';

    let isHiddenPrintClass = !programCode ? 'hidden-print' : 'hidden-print hidden-print-' + programCode;
    let tempCloseBtnClass = !programCode ? 'tempCloseBtn' : 'tempCloseBtn tempCloseBtn-' + programCode;
    let textSucBtnClass = !programCode ? 'textSucBtn' : 'textSucBtn textSucBtn-' + programCode;

    let clientCode = this.selectedExamDetailService.clientCode ? this.selectedExamDetailService.clientCode.toLowerCase() : '';

    if (clientCode) {
      isHiddenPrintClass = !clientCode ? 'hidden-print' : 'hidden-print hidden-print-' + clientCode;
      tempCloseBtnClass = !clientCode ? 'tempCloseBtn' : 'tempCloseBtn tempCloseBtn-' + clientCode;
      textSucBtnClass = !clientCode ? 'textSucBtn' : 'textSucBtn textSucBtn-' + clientCode;
    }

    if (this.isHiddenPrint && this.hasContent !== '') return isHiddenPrintClass + ' ' + textSucBtnClass;
    if (this.isHiddenPrint && this.hasContent === '') return isHiddenPrintClass + ' ' + tempCloseBtnClass;
    if (this.hasContent === '') return tempCloseBtnClass;
    if (this.hasContent !== '') return textSucBtnClass;

    //{ 'hidden-print': isHiddenPrint == true, tempCloseBtn: hasContent == '', 'textSucBtn': hasContent != '' }

  }
}
